let isListenerAdded = false;
document.addEventListener('DOMContentLoaded', function(){
  const selectTrigger = document.querySelector('.custom-select .select-trigger');
  const options = document.querySelectorAll('.option');
  const selectStore = () => {
    selectTrigger.classList.toggle('active');
    document.querySelector('.custom-select .options').classList.toggle('show');
  };

  if (!isListenerAdded) {
    selectTrigger.addEventListener('click', selectStore);
    isListenerAdded = true;
  }
  options.forEach(option => {
    const latitud = parseFloat(option.getAttribute('data-latitude'));
    const longitud = parseFloat(option.getAttribute('data-longitude'));
    const title = option.getAttribute('data-value');
    document.querySelectorAll(".item-store-info").forEach(item => {
      let titleElement = item.querySelector("#name-store").textContent;
      if(titleElement == option.textContent){
        const linkLocation = item.querySelector('#location')
        // const linkLocationImg = item.querySelector('#redirect-img')
        const encodedPlaceName = encodeURIComponent(title.replace(', Lima', ''));
        linkLocation.href = `https://www.google.com/maps/search/${encodedPlaceName} Falabella/@${latitud },${longitud},17z`
        //
      }
    });
    option.addEventListener('click', function() {
      options.forEach(option => {option.style.display = 'block'})
      this.style.display = 'none';
      selectTrigger.querySelector('span').textContent = this.textContent;
      selectTrigger.classList.remove('active');
      document.querySelector('.options').classList.remove('show');
      const nameStore = this.getAttribute('data-value');
      // document.querySelectorAll(".item-store-info").forEach(item => {
      //   item.style.display = "none"            
      // });
      document.querySelector("#section-info-stores .title-info-store").textContent = nameStore;
      document?.querySelectorAll(".item-store-info").forEach(item => {
        let titleElement = item.querySelector("#name-store");
        if (titleElement && nameStore.trim().toUpperCase() == titleElement.textContent.trim().toUpperCase()) {
          // item.style.display = "flex"
          item.scrollIntoView({ behavior: "smooth", block: "center" });
          updateMap(
            latitud,
            longitud,
            nameStore,
            item.querySelector(".title-store p:nth-child(3)")?.textContent,
            item.querySelector(".title-store p:nth-child(4)")?.textContent,
            item.querySelector(".phone-store span")?.getAttribute("data-phone")
          );
        }
      });
      if (!nameStore) {
        initMap();
        document.querySelectorAll(".item-store-info").forEach(item => {
          item.style.display = "flex"
        });
        document.querySelector("#section-info-stores .title-info-store").textContent = "";
      }
    });
  });

  // document.addEventListener('click', function(e) {
  //   if (!selectTrigger.contains(e.target)) {
  //     selectTrigger.classList.remove('active');
  //     document.querySelector('.options').classList.remove('show');
  //   }
  // });

  function updateMap(lat, long, title, address1, address2, phone) {
    const someStores = [
      { location: { lat: lat, lng: long }, title, address1: address1, address2: address2, phone: phone }
    ];
  
    const map = new google.maps.Map(document.getElementById("map-stores"), {
      zoom: 15,
      center: { lat: lat, lng: long }
    });
    someStores.forEach(data => {
      createMarker(data.location, map, data.title, data.address1, data.address2, data.phone);
    });
  }
  
  function initMap() {
    const options = document.querySelectorAll('.option');
    const map = new google.maps.Map(document.getElementById("map-stores"), {
      zoom: 10,
      center: { lat: -33.413831, lng: -70.6168385}
    });
    
    options.forEach(option => {
      const latitud = parseFloat(option.getAttribute('data-latitude'));
      const longitud = parseFloat(option.getAttribute('data-longitude'));
      const title = option.getAttribute('data-value');
      const location ={
        lat:latitud,
        lng:longitud
      }
      createMarker(location, map, title);
    })
  }
  
  function createMarker(position, map, title='', address1='', address2='', phone='') {
    // const content = address2 !== "" ? `<p>${title}<br/>${address1}<br/>${address2}<br/>${phone}</p>` : `<p>${title}<br/>${address1}<br/>${phone}</p>`;
    const marker = new google.maps.Marker({
      map: map,
      position: position
    });
  
    google.maps.event.addListener(marker, 'click', function() {
      const encodedPlaceName = encodeURIComponent(title);
      const url = `https://www.google.com/maps/search/${encodedPlaceName} Falabella/@${position.lat },${position.lng},17z`;
      window.open(url)
    });
  }
  
  window.initMap = initMap;
});
